export default {
  title: 'What\'s Your Style?',
  description: 'Are you drawn to a certain design? Which pieces speak to you? Take our easy style quiz, learn the names to your favorite looks, and we\'ll show you the pieces to pull them together.',
  image: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b23800f8-3818-4e66-ad0c-3c222f5eea4315.jpeg',
  altText: 'Teal lamp, Pink door, colorful rug runner, tapered leg wood console, abstract art',
  questions: [
    {
      question: 'Which living room is your favorite look?',
      layout: 'room',
      maxAllowed: 2,
      sequence: 1,
      guideline: 'Choose up to 2',
      allowNone: true,
      choices: [
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLivingRoom-Farmhouse.png',
          styleCorrelation: 'Farmhouse',
          absPosition: '1',
          collection: 'https://www.homedepot.com/collection/living-room/cozy-farmhouse-living-room/id-37496',
          id: '37496',
          altText: 'rustic wood console, woven rug, shiplap, rolled area chair'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLivingRoom-Industrial.png',
          styleCorrelation: 'Industrial',
          absPosition: '5',
          collection: 'https://www.homedepot.com/collection/living-room/urban-modern-living-room/id-37774',
          id: '37774',
          altText: 'white leather sofa, metal pendant, brick wall, steel frame windows, tall ceilings'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLivingRoom-Cottage.png',
          styleCorrelation: 'Cottage',
          absPosition: '8',
          collection: 'https://www.homedepot.com/collection/living-room/cottage-living-room/id-32829',
          id: '32829',
          altText: 'slip cover sofa, blue arm chair, weather wood console, window shutters'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLivingRoom-Glam.png',
          styleCorrelation: 'Glam',
          absPosition: '6',
          collection: 'https://www.homedepot.com/collection/living-room/classic-glamour-living-room/id-37163',
          id: '37163',
          altText: 'pink tufted chair, gold coffee table, tufted sofa, gold floor lamp, gold side table'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLivingRoom-Traditional.png',
          styleCorrelation: 'Traditional',
          absPosition: '4',
          collection: 'https://www.homedepot.com/collection/living-room/urban-modern-living-room/id-1003',
          id: '1003',
          altText: 'brown leather sofas, glass lamps, wood coffee table, wood framed fireplace'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLivingRoom-MCModern.png',
          styleCorrelation: 'Mid Century Modern',
          absPosition: '9',
          collection: 'https://www.homedepot.com/collection/living-room/modern-drama-sitting-room/id-38022',
          id: '38022',
          altText: 'taper leg chair, geometric rug, cream leather seating, wooden tapped leg end table'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLivingRoom-Bohemian.png',
          styleCorrelation: 'Bohemian',
          absPosition: '3',
          collection: 'https://www.homedepot.com/collection/living-room/justina-blakeney/id-37078',
          id: '37078',
          altText: 'Hand carved wood, colorful pillows, lush plants, woven pouf, velvet sofa'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLivingRoom-Coastal.png',
          styleCorrelation: 'Coastal',
          absPosition: '7',
          collection: 'https://www.homedepot.com/collection/living-room/global-coastal-living-room/id-954',
          id: '954',
          altText: 'ocean art, blue rug, rattan chairs, large window, wooden stools'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLivingRoom-Modern.png',
          styleCorrelation: 'Modern',
          absPosition: '2',
          collection: 'https://www.homedepot.com/collection/living-room/mod-marble-living-room/id-37753',
          id: '37753',
          altText: 'carmel color, leather sofa, steel legs, black & white art, white rug, metal side table'
        }
      ]
    },
    {
      question: 'Which chair would you choose?',
      layout: 'product',
      maxAllowed: 2,
      sequence: 2,
      guideline: 'Choose up to 2',
      allowNone: true,
      choices: [
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizChairs-Option3.png',
          styleCorrelation: 'Modern',
          absPosition: '3',
          omsid: '305554820',
          altText: 'stainless steel frame, white faux leather, Buttons, Square frame arms'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizChairs-Option8.png',
          styleCorrelation: 'Cottage',
          absPosition: '8',
          omsid: '310229096',
          altText: 'rolled arm chair, linen, wheels, overstuffed seat'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizChairs-Option4.png',
          styleCorrelation: 'Farmhouse',
          absPosition: '4',
          omsid: '307889108',
          altText: 'Fabric, Checkered Design, Thick cushion, sturdy construction'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizChairs-Option6.png',
          styleCorrelation: 'Coastal',
          absPosition: '6',
          omsid: '308177397',
          altText: 'rattan, 100% Linen, Removable cushion, barrel frame'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizChairs-Option1.png',
          styleCorrelation: 'Mid Century Modern',
          absPosition: '1',
          omsid: '305553784',
          altText: 'tailored lines, gray fabric, back buttons, tapered wood legs'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizChairs-Option5.png',
          styleCorrelation: 'Industrial',
          absPosition: '5',
          omsid: '309366021',
          altText: 'removable cushion, brown leather, metal frame, pillowback cushions'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizChairs-Option9.png',
          styleCorrelation: 'Bohemian',
          absPosition: '9',
          omsid: '205409568',
          altText: 'barrel back, yellow velvet, tufted back, rolled arms'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizChairs-Option2.png',
          styleCorrelation: 'Glam',
          absPosition: '2',
          omsid: '312276082',
          altText: 'pink velvet, gold legs, vertical channel tufting, Removable Cushion, curved back'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizChairs-Option7.png',
          styleCorrelation: 'Traditional',
          absPosition: '7',
          omsid: '205181527',
          altText: 'Decorative nailhead trim, Casters on front legs, tufted buttons, linen fabric'
        }
      ]
    },
    {
      question: 'Which coffee table catches your eye?',
      layout: 'product',
      maxAllowed: 2,
      sequence: 3,
      guideline: 'Choose up to 2',
      allowNone: true,
      choices: [
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoffeeTables-Option5.png',
          styleCorrelation: 'Cottage',
          absPosition: '5',
          omsid: '304257378',
          altText: 'rustic wood, white turned legs, natural top, trestle table'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoffeeTables-Option9.png',
          styleCorrelation: 'Farmhouse',
          absPosition: '9',
          omsid: '308537959',
          altText: 'solid wood, drawer, square, weather gray stain'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoffeeTables-Option4.png',
          styleCorrelation: 'Coastal',
          absPosition: '4',
          omsid: '301812884',
          altText: 'white paint, square, solid wood, X shape sides'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoffeeTables-Option8.png',
          styleCorrelation: 'Modern',
          absPosition: '8',
          omsid: '206990297',
          altText: 'solid wood top, gold metal legs, geometric lines, rectangle'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoffeeTables-Option3.png',
          styleCorrelation: 'Mid Century Modern',
          absPosition: '3',
          omsid: '309755749',
          altText: 'round, wood, lower shelf, brass capped legs, beveled top'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoffeeTables-Option7.png',
          styleCorrelation: 'Industrial',
          absPosition: '7',
          omsid: '309089364',
          altText: 'large rectangle, metal casters, espresso stain, rustic wood'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoffeeTables-Option2.png',
          styleCorrelation: 'Glam',
          absPosition: '2',
          omsid: '312957358',
          altText: 'nesting tables, white marble, round, gold legs'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoffeeTables-Option6.png',
          styleCorrelation: 'Bohemian',
          absPosition: '6',
          omsid: '309755928',
          altText: 'hexagonal, turned legs, walnut stain, lower shelf'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoffeeTables-Option1.png',
          styleCorrelation: 'Traditional',
          absPosition: '1',
          omsid: '304284674',
          altText: 'oval, lower shelf, smooth dark walnut stain, mirror top, turned leg'
        }
      ]
    },
    {
      question: 'Which dining room do you desire?',
      layout: 'room',
      maxAllowed: 2,
      sequence: 4,
      guideline: 'Choose up to 2',
      allowNone: true,
      choices: [
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizDiningRoom-Modern.png',
          styleCorrelation: 'Modern',
          absPosition: '3',
          collection: 'https://www.homedepot.com/collection/dining-room/bold-bungalow-dining-room/id-36929',
          id: '36929',
          altText: 'gold chandelier, leather dining chair, gold table lamp'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizDiningRoom-Cottage.png',
          styleCorrelation: 'Cottage',
          absPosition: '7',
          collection: 'https://www.homedepot.com/collection/dining-room/earthy-cottage-dining-room/id-38083',
          id: '38083',
          altText: 'Trestle pendant, dining bench, Grey buffet'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizDiningRoom-Farmhouse.png',
          styleCorrelation: 'Farmhouse',
          absPosition: '8',
          collection: 'https://www.homedepot.com/collection/dining-room/modern-farmhouse-dining-room/id-936',
          id: '936',
          altText: 'white shiplap wall, black barn door, high back wooden dining chair'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizDiningRoom-Coastal.png',
          styleCorrelation: 'Coastal',
          absPosition: '1',
          collection: 'https://www.homedepot.com/collection/dining-room/global-coastal-dining-room/id-914',
          id: '914',
          altText: 'blue wall, ratan chair, wooden dining bench'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizDiningRoom-MCModern.png',
          styleCorrelation: 'Mid Century Modern',
          absPosition: '5',
          collection: 'https://www.homedepot.com/collection/dining-room/mod-mix-dining-room/id-36896',
          id: '36896',
          altText: 'Round wooden mirror, wooden floor lamp, Yellow wall'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizDiningRoom-Industrial.png',
          styleCorrelation: 'Industrial',
          absPosition: '2',
          collection: 'https://www.homedepot.com/collection/dining-room/in-the-moment-dining-room/id-32878',
          id: '32878',
          altText: 'grasscloth wallpaper, upholstered dining chair, sisal rug'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizDiningRoom-Glam.png',
          styleCorrelation: 'Glam',
          absPosition: '4',
          collection: 'https://www.homedepot.com/collection/dining-room/holiday-glamour-dining-room/id-37689',
          id: '37689',
          altText: 'Crystal chandelier, gold mirror, blue velvet dining chair'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizDiningRoom-Bohemian.png',
          styleCorrelation: 'Bohemian',
          absPosition: '6',
          collection: 'https://www.homedepot.com/collection/dining-room/voyage-dining-room/id-32863',
          id: '32863',
          altText: 'Blue dining chair, Teal walls, Round gold mirrors'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizDiningRoom-Traditional.png',
          styleCorrelation: 'Traditional',
          absPosition: '9',
          collection: 'https://www.homedepot.com/collection/dining-room/natural-classic-dining/id-32217',
          id: '32217',
          altText: 'White Linen curtains, upholstered dining chairs, round white mirror'
        }
      ]
    },
    {
      question: 'Which light fixture do you fancy?',
      layout: 'product',
      maxAllowed: 2,
      sequence: 5,
      guideline: 'Choose up to 2',
      allowNone: true,
      choices: [
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLightFixture-Option2.png',
          styleCorrelation: 'Modern',
          absPosition: '2',
          omsid: '206852069',
          altText: 'circular silver chandelier,  simple round'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLightFixture-Option5.png',
          styleCorrelation: 'Cottage',
          absPosition: '5',
          omsid: '205980761',
          altText: 'white light brown beachwood 5 light chalk washed'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLightFixture-Option1.png',
          styleCorrelation: 'Farmhouse',
          absPosition: '1',
          omsid: '306300175',
          altText: '5 light rectangular wood and black pendant'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLightFixture-Option7.png',
          styleCorrelation: 'Coastal',
          absPosition: '7',
          omsid: '304196562',
          altText: '5 light drum pendant weathered white wood'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLightFixture-Option9.png',
          styleCorrelation: 'Mid Century Modern',
          absPosition: '9',
          omsid: '303998103',
          altText: 'brass chandelier with glass balls'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLightFixture-Option3.png',
          styleCorrelation: 'Industrial',
          absPosition: '3',
          omsid: '206611429',
          altText: 'iron, rubbed bronze chandelier, four lights'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLightFixture-Option8.png',
          styleCorrelation: 'Glam',
          absPosition: '8',
          omsid: '300119194',
          altText: 'laser cut crystal island chandelier, rectangular silver'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLightFixture-Option4.png',
          styleCorrelation: 'Bohemian',
          absPosition: '4',
          omsid: '310243577',
          altText: 'Natural finish, cage style single light pendant'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizLightFixture-Option6.png',
          styleCorrelation: 'Traditional',
          absPosition: '6',
          omsid: '206058922',
          altText: 'oil rubbed bronze with 5 white glass shades'
        }
      ]
    },
    {
      question: 'Which work of art are you drawn to?',
      layout: 'product',
      maxAllowed: 2,
      sequence: 6,
      guideline: 'Choose up to 2',
      allowNone: true,
      choices: [
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizArt-Option7.png',
          styleCorrelation: 'Cottage',
          absPosition: '7',
          omsid: '303450549',
          altText: 'blue flowers butterfly painting'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizArt-Option9.png',
          styleCorrelation: 'Farmhouse',
          absPosition: '9',
          omsid: '303128249',
          altText: 'black framed black and white photograph of barn'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizArt-Option5.png',
          styleCorrelation: 'Coastal',
          absPosition: '5',
          omsid: '305358769',
          altText: 'beach scene with wooden frame, pastel'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizArt-Option8.png',
          styleCorrelation: 'Modern',
          absPosition: '8',
          omsid: '305168803',
          altText: 'abstract multi color painting'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizArt-Option6.png',
          styleCorrelation: 'Mid Century Modern',
          absPosition: '6',
          omsid: '313340304',
          altText: 'wooden framed artwork pink yellow orange abstract'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizArt-Option3.png',
          styleCorrelation: 'Industrial',
          absPosition: '3',
          omsid: '312734515',
          altText: 'glossy black metal lines circular'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizArt-Option2.png',
          styleCorrelation: 'Glam',
          absPosition: '2',
          omsid: '310582240',
          altText: 'pink flower xray large square'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizArt-Option1.png',
          styleCorrelation: 'Bohemian',
          absPosition: '1',
          omsid: '303821876',
          altText: 'carved wooden flowers and flourishes'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizArt-Option4.png',
          styleCorrelation: 'Traditional',
          absPosition: '4',
          omsid: '300921175',
          altText: 'painting of river scene blue with red boat'
        }
      ]
    },
    {
      question: 'Which bed is begging to be yours?',
      layout: 'product',
      maxAllowed: 2,
      sequence: 7,
      guideline: 'Choose up to 2',
      allowNone: true,
      choices: [
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBeds-Option2.png',
          styleCorrelation: 'Cottage',
          absPosition: '2',
          omsid: '308476388',
          altText: 'white, curved headboard, no footboard'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBeds-Option4.png',
          styleCorrelation: 'Farmhouse',
          absPosition: '4',
          omsid: '204389848',
          altText: 'antique brown, metal, headboard and footboard'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBeds-Option6.png',
          styleCorrelation: 'Coastal',
          absPosition: '6',
          omsid: '308420006',
          altText: 'seagrass headboard, natural finish, wood frame'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBeds-Option9.png',
          styleCorrelation: 'Modern',
          absPosition: '9',
          omsid: '308661807',
          altText: 'slate gray, upholstered faux leather headboard'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBeds-Option8.png',
          styleCorrelation: 'Mid Century Modern',
          absPosition: '8',
          omsid: '309832322',
          altText: 'mahogany wood headboard, wood frame, no footboard'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBeds-Option1.png',
          styleCorrelation: 'Industrial',
          absPosition: '1',
          omsid: '308278626',
          altText: 'black metal, platform bed with slats, powder coated finish'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBeds-Option7.png',
          styleCorrelation: 'Glam',
          absPosition: '7',
          omsid: '308448628',
          altText: 'beige upholstered linen headboard, curved, no footboard, nailhead trim'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBeds-Option5.png',
          styleCorrelation: 'Bohemian',
          absPosition: '5',
          omsid: '308139919',
          altText: 'white washed carved wood headboard, no footboard, mango wood frame'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBeds-Option3.png',
          styleCorrelation: 'Traditional',
          absPosition: '3',
          omsid: '311041666',
          altText: 'ebony wood bed, headboard and footboard'
        }
      ]
    },
    {
      question: 'Which accent pillow completes your look?',
      layout: 'product',
      maxAllowed: 2,
      sequence: 8,
      guideline: 'Choose up to 2',
      allowNone: true,
      choices: [
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizPillows-Option4.png',
          styleCorrelation: 'Cottage',
          absPosition: '4',
          omsid: '306180264',
          altText: 'denim blue, textured, diamond tufted'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizPillows-Option6.png',
          styleCorrelation: 'Farmhouse',
          absPosition: '6',
          omsid: '310442197',
          altText: 'ticking stripe with vintage cow graphic, tan and black'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizPillows-Option7.png',
          styleCorrelation: 'Coastal',
          absPosition: '7',
          omsid: '309841854',
          altText: 'blue grey and beige stripes, quilted, navy trim'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizPillows-Option3.png',
          styleCorrelation: 'Modern',
          absPosition: '3',
          omsid: '302554867',
          altText: 'stone grey, white and yellow, block print'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizPillows-Option8.png',
          styleCorrelation: 'Mid Century Modern',
          absPosition: '8',
          omsid: '311195590',
          altText: 'blue, red, green and white, geometric pattern'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizPillows-Option9.png',
          styleCorrelation: 'Industrial',
          absPosition: '9',
          omsid: '310056585',
          altText: 'brown leather, white stitching'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizPillows-Option1.png',
          styleCorrelation: 'Glam',
          absPosition: '1',
          omsid: '303724644',
          altText: 'light pink and gold, geometric pattern'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizPillows-Option5.png',
          styleCorrelation: 'Bohemian',
          absPosition: '5',
          omsid: '302162521',
          altText: 'multi-colored, textured, geometric, tribal pattern'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizPillows-Option2.png',
          styleCorrelation: 'Traditional',
          absPosition: '2',
          omsid: '300905122',
          altText: 'embroidered damask pattern, dark red and ivory, textured'
        }
      ]
    },
    {
      question: 'Which wallpaper pattern speaks to you?',
      layout: 'product',
      maxAllowed: 2,
      sequence: 9,
      guideline: 'Choose up to 2',
      allowNone: true,
      choices: [
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizWallpaper-Option8.png',
          styleCorrelation: 'Cottage',
          absPosition: '8',
          omsid: '301440018',
          altText: 'buffalo check, watercolor, gray and white'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizWallpaper-Option3.png',
          styleCorrelation: 'Farmhouse',
          absPosition: '3',
          omsid: '301440077',
          altText: 'shiplap, weathered, woodgrain, gray'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizWallpaper-Option5.png',
          styleCorrelation: 'Coastal',
          absPosition: '5',
          omsid: '308594498',
          altText: 'tropical leaves, blue and white, botanical print'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizWallpaper-Option1.png',
          styleCorrelation: 'Modern',
          absPosition: '1',
          omsid: '304138090',
          altText: 'navy blue and white, geometric print, thin lines'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizWallpaper-Option7.png',
          styleCorrelation: 'Mid Century Modern',
          absPosition: '7',
          omsid: '310387276',
          altText: 'shades of blue and green, geometric shapes'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizWallpaper-Option9.png',
          styleCorrelation: 'Industrial',
          absPosition: '9',
          omsid: '308657449',
          altText: 'red brick pattern, distressed'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizWallpaper-Option2.png',
          styleCorrelation: 'Glam',
          absPosition: '2',
          omsid: '309326502',
          altText: 'black background, white floral print, photographic'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizWallpaper-Option6.png',
          styleCorrelation: 'Bohemian',
          absPosition: '6',
          omsid: '307858819',
          altText: 'multi-colored floral print, teal background, vintage, botanical'
        },
        {
          url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizWallpaper-Option4.png',
          styleCorrelation: 'Traditional',
          absPosition: '4',
          omsid: '302259305',
          altText: 'grey linen damask, silver background'
        }
      ]
    }
  ],
  results: {
    Modern: {
      campaignId: '1377',
      description: 'You\'ve got sleek style and a modern mood. Clean and minimalistic, your favorite designs focus on function over form. You thrive in elegant spaces where each piece serves an essential purpose and no detail is unnecessary. Open living spaces make you swoon, adorned with geometric patterns and artful lines. Looks you love celebrate neutral colors, streamlined silhouettes and the sleekest materials.',
      elements: [
        {
          type: 'element-1',
          title: 'Geometric Shapes',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-Style1.png'
        },
        {
          type: 'element-2',
          title: 'Clean Design Lines',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-Style2.png'
        },
        {
          type: 'element-3',
          title: 'Abstract Art',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-Style3.png'
        }
      ],
      media: {
        images: [
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-modern-moment-living-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/living-room/modern-moment-living-room/id-35513',
            collectionId: '35513'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/DR-bold-bungalow-dining-room-SQ.jpg ',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/dining-room/bold-bungalow-dining-room/id-38134',
            collectionId: '38134'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/BR-bold-bungalow-bedroom-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/bedroom/bold-bungalow-bedroom/id-38137',
            collectionId: '38137'
          }
        ]
      },
      rooms: [
        {
          id: '38330',
          url: 'https://www.homedepot.com/collection/bathroom/chic-retreat-bathroom/id-38330',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/4f20fc2c-5495-487c-9210-6969b08f663313.jpeg'
        },
        {
          id: '38328',
          url: 'https://www.homedepot.com/collection/bedroom/chic-retreat-bedroom/id-38328',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/4e4eade0-df5a-43f6-a4f3-ed89752af92712.jpeg'
        },
        {
          id: '38326',
          url: 'https://www.homedepot.com/collection/dining-room/chic-retreat-dining-area/id-38326',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/c5ace81b-43ea-4428-bb47-a7d528ba7c0211.jpeg'
        },
        {
          id: '38324',
          url: 'https://www.homedepot.com/collection/living-room/chic-retreat-living-room/id-38324',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/8481a6df-f0dd-45f6-a0be-e59b3f0690d010.jpeg'
        },
        {
          id: '38316',
          url: 'https://www.homedepot.com/collection/dorm-room/sophisticated-workspace/id-38316',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/dbcaad6a-24b6-411e-95b5-f3192f4d873a6.jpeg'
        },
        {
          id: '38305',
          url: 'https://www.homedepot.com/collection/dorm-room/colorful-corner/id-38305',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/d98b0888-51d5-493e-9728-3edc367a0a7e0.jpeg'
        },
        {
          id: '38290',
          url: 'https://www.homedepot.com/collection/bedroom/classic-bedroom/id-38290',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/e0977292-1427-4f37-b69e-92e067e6eea15.jpeg'
        },
        {
          id: '38296',
          url: 'https://www.homedepot.com/collection/bedroom/refined-room-for-two/id-38296',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/922fdb77-c51c-4cdc-99b3-1358202e74516.jpeg'
        },
        {
          id: '38246',
          url: 'https://www.homedepot.com/collection/bedroom/petite-suite-murphy-bed/id-38246',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b810e6f2-449b-4b10-bbe6-16e4a77f8d7e1.jpeg'
        },
        {
          id: '38239',
          url: 'https://www.homedepot.com/collection/living-room/petite-suite-living-room/id-38239',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/51ac18a1-43b8-4586-ab30-d315d67385d50.jpeg'
        },
        {
          id: '38242',
          url: 'https://www.homedepot.com/collection/dining-room/petite-suite-dining-room/id-38242',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b5c5ebd7-3e18-4106-800b-905f04dfbc622.jpeg'
        },
        {
          id: '38236',
          url: 'https://www.homedepot.com/collection/entryway/petite-suite-entryway/id-38236',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/1112953f-4418-4afb-ac24-780e863be3371.jpeg'
        },
        {
          id: '38231',
          url: 'https://www.homedepot.com/collection/bedroom/earthy-explorer-bedroom/id-38231',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/e4ee5236-24ef-4205-a173-d3c389f704351.jpeg'
        },
        {
          id: '38022',
          url: 'https://www.homedepot.com/collection/living-room/modern-drama-sitting-room/id-38022',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/22b53c4b-4e32-4276-b3e8-f798a7e40cef138.jpeg'
        },
        {
          id: '38015',
          url: 'https://www.homedepot.com/collection/bathroom/modern-spa-retreat/id-38015',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/4247c9f1-9de9-4df7-9dfd-e2cb31c497a079.jpeg'
        },
        {
          id: '38011',
          url: 'https://www.homedepot.com/collection/bedroom/organic-modern-bedroom/id-38011',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/a08df011-229a-4868-8ea3-fd5d9c20f93280.jpeg'
        },
        {
          id: '38014',
          url: 'https://www.homedepot.com/collection/bathroom/minimalist-farmhouse-bathroom/id-38014',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/e1bf13ef-6fbd-4fdc-8645-4210873ca5a0139.jpeg'
        },
        {
          id: '37992',
          url: 'https://www.homedepot.com/collection/home-office/posh-modern-home-office/id-37992',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/cf00f950-3455-4afb-93ef-84c338bf35f5143.jpeg'
        },
        {
          id: '37987',
          url: 'https://www.homedepot.com/collection/kitchen/mixed-modern-kitchen/id-37987',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/09b8776c-1885-478c-adb4-2397225d53ad124.jpeg'
        },
        {
          id: '37915',
          url: 'https://www.homedepot.com/collection/living-room/organic-elegance-sitting-room/id-37915',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/89252a9b-03cb-4f00-aa2e-e7a0345e2dc00.jpeg'
        }
      ],
      visualNav: [
        {
          url: 'https://www.homedepot.com/b/Furniture-Bedroom-Furniture/Modern/N-5yc1vZc7peZ1z0jylo?NCNI-5',
          omsid: 303074500,
          title: 'Bedroom',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav1.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Living-Room-Furniture/Modern/N-5yc1vZc7p3Z1z0jylo?NCNI-5',
          omsid: 301373574,
          title: 'Living Room',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav2.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Home-Office-Furniture/Modern/N-5yc1vZc7npZ1z0jylo?NCNI-5',
          omsid: 307742152,
          title: 'Home Office',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav3.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Wallpaper/Modern/N-5yc1vZbc0qZ1z0wuk1?NCNI-5',
          omsid: 308693366,
          title: 'Wallpaper',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav4.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Kitchen-Dining-Room-Furniture/Modern/N-5yc1vZc7ouZ1z0wuk1?NCNI-5',
          omsid: 307632958,
          title: 'Kitchen & Dining',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav5.png'
        },
        {
          url: 'https://www.homedepot.com/b/Bath-Bathroom-Vanities/Modern/N-5yc1vZcfv3Z1z0jylo?NCNI-5',
          omsid: 300851618,
          title: 'Bathroom Vanities',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav6.png'
        },
        {
          url: 'https://www.homedepot.com/b/Flooring-Rugs-Area-Rugs/Modern/N-5yc1vZarjgZ1z0jylo?NCNI-5',
          omsid: 206503969,
          title: 'Area Rugs',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav7.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Mirrors/Modern/N-5yc1vZbve6Z1z17z2o?NCNI-5',
          omsid: 309771466,
          title: 'Mirrors',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav8.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Entryway-Furniture/Modern/N-5yc1vZc7ozZ1z0jylo?NCNI-5',
          omsid: 306336448,
          title: 'Entryway',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav9.png'
        },
        {
          url: 'https://www.homedepot.com/b/Featured-Products-Lighting-Trending-Interior-Lighting/Modern/N-5yc1vZ1z18gixZ1z0jylo?NCNI-5&experienceName=default',
          omsid: 312950538,
          title: 'Indoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav10.png'
        },
        {
          url: 'https://www.homedepot.com/b/Lighting-Outdoor-Lighting/Modern/N-5yc1vZc7qvZ1z0jylo?NCNI-5',
          omsid: 313742822,
          title: 'Outdoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav11.png'
        },
        {
          url: 'https://www.homedepot.com/b/Outdoors-Patio-Furniture/Modern/N-5yc1vZbx4oZ1z0jylo?NCNI-5',
          omsid: 302929144,
          title: 'Patio Furniture',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizModern-VizNav12.png'
        }
      ]
    },
    Cottage: {
      campaignId: '1372',
      description: 'Quaint and calming, your cottage style focuses on simple details, soft upholstered silhouettes and restful horizontal lines. Comfortable woven fabrics and colors from nature let you breathe deep the moment you arrive. Surfaces in your space are low in luster like painted pieces, natural wood finishes and cool iron. Each of your cottage rooms have a light, elegant air, styled to avoid perfect symmetry and relax the senses.',
      elements: [
        {
          type: 'element-1',
          title: 'Weathered Finishes',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-Style1.png'
        },
        {
          type: 'element-2',
          title: 'Low Luster Fabric',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-Style2.png'
        },
        {
          type: 'element-3',
          title: 'Soft Color Palette',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-Style3.png'
        }
      ],
      media: {
        images: [
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-airy-classic-sunroom-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/living-room/airy-classic-sunroom/id-37064',
            collectionId: '37064'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/DR-earthy-cottage-dining-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/dining-room/earthy-cottage-dining-room/id-38083',
            collectionId: '38083'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/BR-classic-elegance-bedroom-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/bedroom/classic-elegance-bedroom/id-36914',
            collectionId: '36914'
          }
        ]
      },
      rooms: [
        {
          id: '38292',
          url: 'https://www.homedepot.com/collection/living-room/classic-living-room/id-38292',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/61151ee6-8213-4458-b826-9ce0484cdfb33.jpeg'
        },
        {
          id: '38252',
          url: 'https://www.homedepot.com/collection/bathroom/petite-suite-bathroom/id-38252',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/ebf77940-3ead-4257-a8fa-3a77d7a18e2a3.jpeg'
        },
        {
          id: '38159',
          url: 'https://www.homedepot.com/collection/living-room/casual-charm-den/id-38159',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/dd021947-d19d-4a13-9cd8-f623a30af5860.jpeg'
        },
        {
          id: '38119',
          url: 'https://www.homedepot.com/collection/dining-room/colorful-comfort-breakfast-nook/id-38119',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/0d579cdc-0a73-450d-a1e8-1fc67ff93ea92.jpeg'
        },
        {
          id: '38100',
          url: 'https://www.homedepot.com/collection/living-room/starring-the-chesterfield-sofa/id-38100',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3e9abdb1-d880-4b24-86f6-1398bf97a3eb9.jpeg'
        },
        {
          id: '38097',
          url: 'https://www.homedepot.com/collection/entryway/gentle-comforts-mudroom/id-38097',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/227c4b5f-b8e1-48d7-b53b-48562d36fbd36.jpeg'
        },
        {
          id: '38092',
          url: 'https://www.homedepot.com/collection/bedroom/gentle-comforts-bedroom/id-38092',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b3eafd40-d9ae-49a7-8e63-9b52e8406e9b8.jpeg'
        },
        {
          id: '38086',
          url: 'https://www.homedepot.com/collection/home-office/earthy-cottage-home-office/id-38086',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/0dfb7035-18f9-43d1-b0e1-3c64ec37d93d3.jpeg'
        },
        {
          id: '38078',
          url: 'https://www.homedepot.com/collection/living-room/earthy-cottage-living-room/id-38078',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/6f646e41-9c65-45af-9042-aab0e1dcb1fd0.jpeg'
        },
        {
          id: '38083',
          url: 'https://www.homedepot.com/collection/dining-room/earthy-cottage-dining-room/id-38083',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/68f93dea-7f04-4080-9e70-592fd59fefce2.jpeg'
        },
        {
          id: '38080',
          url: 'https://www.homedepot.com/collection/entryway/earthy-cottage-entryway/id-38080',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/f597a749-4c11-4786-b05b-43958295520d1.jpeg'
        },
        {
          id: '37979',
          url: 'https://www.homedepot.com/collection/living-room/classically-cozy-living-room/id-37979',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/133f6932-e4f9-4eef-add7-3dec75318868197.jpeg'
        },
        {
          id: '38028',
          url: 'https://www.homedepot.com/collection/kitchen/warm-neutrals-kitchen/id-38028',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/0104b060-334e-428f-a6a6-0859a214bd78194.jpeg'
        },
        {
          id: '37994',
          url: 'https://www.homedepot.com/collection/laundry-room/cottage-fresh-laundry-room/id-37994',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/44d52d2c-7f29-4428-9f12-b244700bbab7185.jpeg'
        },
        {
          id: '37925',
          url: 'https://www.homedepot.com/collection/laundry-room/welcoming-cottage-laundry-room/id-37925',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/964991ab-fb70-4713-a5e7-360c4ffea683163.jpeg'
        },
        {
          id: '37972',
          url: 'https://www.homedepot.com/collection/laundry-room/essential-coastal-laundry-room/id-37972',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/abb330a1-a454-480b-b15d-57a466053300115.jpeg'
        },
        {
          id: '37935',
          url: 'https://www.homedepot.com/collection/entryway/soft-sanctuary-entryway/id-37935',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/1526d0c1-036a-4dc4-acce-1c0db7d59a0b2.jpeg'
        },
        {
          id: '37875',
          url: 'https://www.homedepot.com/collection/living-room/organic-elegance-living-room/id-37875',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/6bc3ff9e-f9eb-458a-ac3e-f44c50c073a333.jpeg'
        },
        {
          id: '37893',
          url: 'https://www.homedepot.com/collection/entryway/cozy-farmhouse-mudroom/id-37893',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/9f6ceef7-3484-4e3e-9adf-c72e05f6e17740.jpeg'
        },
        {
          id: '37888',
          url: 'https://www.homedepot.com/collection/home-office/cozy-farmhouse-office/id-37888',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/6728ca24-9209-4666-a16f-bd0dda170bfa38.jpeg'
        }
      ],
      visualNav: [
        {
          url: 'https://www.homedepot.com/b/Furniture-Bedroom-Furniture/Cottage/N-5yc1vZc7peZ1z0jykp?sortby=topsellers&sortorder=desc',
          omsid: 311041242,
          title: 'Bedroom',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav1.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Living-Room-Furniture/Cottage/N-5yc1vZc7p3Z1z0jykp?sortby=topsellers&sortorder=desc',
          omsid: 205181861,
          title: 'Living Room',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav2.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Home-Office-Furniture/Cottage/N-5yc1vZc7npZ1z0jykp?sortby=topsellers&sortorder=desc',
          omsid: 206616511,
          title: 'Home Office',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav3.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Wallpaper/Cottage/N-5yc1vZbc0qZ1z0wuk3?sortby=topsellers&sortorder=desc',
          omsid: 301740163,
          title: 'Wallpaper',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav4.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Kitchen-Dining-Room-Furniture/Cottage/N-5yc1vZc7ouZ1z0wuk3?sortby=topsellers&sortorder=desc',
          omsid: 203683550,
          title: 'Kitchen & Dining',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav5.png'
        },
        {
          url: 'https://www.homedepot.com/b/Bath-Bathroom-Vanities/Cottage/N-5yc1vZcfv3Z1z0jykp?sortby=topsellers&sortorder=desc',
          omsid: 300173074,
          title: 'Bathroom Vanities',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav6.png'
        },
        {
          url: 'https://www.homedepot.com/b/Flooring-Rugs-Area-Rugs/Cottage/N-5yc1vZarjgZ1z0jykp?sortby=topsellers&sortorder=desc',
          omsid: 300683962,
          title: 'Area Rugs',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav7.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Mirrors/Cottage/N-5yc1vZbve6Z1z17yzd?NCNI-5',
          omsid: 310684833,
          title: 'Mirrors',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav8.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Entryway-Furniture/Cottage/N-5yc1vZc7ozZ1z0jykp?sortby=topsellers&sortorder=desc',
          omsid: 310979192,
          title: 'Entryway',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav9.png'
        },
        {
          url: 'https://www.homedepot.com/b/Featured-Products-Lighting-Trending-Interior-Lighting/Cottage/N-5yc1vZ1z18gixZ1z0jykp?NCNI-5&experienceName=default',
          omsid: 309945685,
          title: 'Indoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav10.png'
        },
        {
          url: 'https://www.homedepot.com/b/Lighting-Outdoor-Lighting/Cottage/N-5yc1vZc7qvZ1z0jykp?NCNI-5',
          omsid: 311437942,
          title: 'Outdoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav11.png'
        },
        {
          url: 'https://www.homedepot.com/b/Outdoors-Patio-Furniture/Cottage/N-5yc1vZbx4oZ1z0jykp?NCNI-5',
          omsid: 203974313,
          title: 'Patio Furniture',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCottage-VizNav12.png'
        }
      ]
    },
    Farmhouse: {
      campaignId: '1373',
      description: 'Your farmhouse style is simply sublime. Charming and full of character, your favorite rooms are airy yet cozy at the same time. When you design your space, you focus on multi-purpose pieces and practical touches. To you, the look is incomplete without touchable textures like woven rugs, supple leather upholstery and wooden wall treatments. Light fixtures with distressed wood, twisted rope and cage detailing catch your eye, while checkered fabrics call your name.',
      elements: [
        {
          type: 'element-1',
          title: 'Metal Accents',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-Style1.png'
        },
        {
          type: 'element-2',
          title: 'Woven Rugs',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-Style2.png'
        },
        {
          type: 'element-3',
          title: 'Buffalo Check Prints',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-Style3.png'
        }
      ],
      media: {
        images: [
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-american-farmhouse-living-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/living-room/american-farmhouse-living/id-26058',
            collectionId: '26058'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/DR-modern-farmhouse-dining-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/dining-room/modern-farmhouse-dining-room/id-936',
            collectionId: '936'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/BR-flexible-farmhouse-bedroom-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/bedroom/flexible-farmhouse-bedroom/id-372',
            collectionId: '372'
          }
        ]
      },
      rooms: [
        {
          id: '38287',
          url: 'https://www.homedepot.com/collection/kitchen/farmhouse-breakfast-nook/id-38287',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/d1448ca3-5103-4c54-a0ce-cfbba6944e560.jpeg'
        },
        {
          id: '38176',
          url: 'https://www.homedepot.com/collection/living-room/farmhouse-living-room/id-38176',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/485077c9-4d42-4142-88c8-b212f64d31781.jpeg'
        },
        {
          id: '38140',
          url: 'https://www.homedepot.com/collection/laundry-room/bold-bungalow-laundry-room/id-38140',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/aa2b74fd-2b62-4dd6-8810-2711c178a91f2.jpeg'
        },
        {
          id: '38124',
          url: 'https://www.homedepot.com/collection/entryway/bold-bungalow-entryway/id-38124',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3164300e-39a1-43c0-a455-90b7eb934af40.jpeg'
        },
        {
          id: '38117',
          url: 'https://www.homedepot.com/collection/dining-room/colorful-comfort-dining-room/id-38117',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/cc6653a8-d710-4ed4-8af0-a1738139456b16.jpeg'
        },
        {
          id: '38030',
          url: 'https://www.homedepot.com/collection/kitchen/statement-farmhouse-kitchen/id-38030',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/d4d2b51a-80bd-467d-9562-a13662dc0b5e86.jpeg'
        },
        {
          id: '38020',
          url: 'https://www.homedepot.com/collection/laundry-room/farmhouse-twist-laundry-room/id-38020',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b3e5c48c-d962-4d75-bfe6-3332959a494b90.jpeg'
        },
        {
          id: '38024',
          url: 'https://www.homedepot.com/collection/kitchen/delightful-farmhouse-kitchen/id-38024',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/c50cdb51-b829-47bb-b468-771b68445df7113.jpeg'
        },
        {
          id: '38016',
          url: 'https://www.homedepot.com/collection/living-room/quaint-classic-living-room/id-38016',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/f2ce73b9-5c19-4382-ade9-10203fb4858c109.jpeg'
        },
        {
          id: '38014',
          url: 'https://www.homedepot.com/collection/bathroom/minimalist-farmhouse-bathroom/id-38014',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/e1bf13ef-6fbd-4fdc-8645-4210873ca5a0139.jpeg'
        },
        {
          id: '38009',
          url: 'https://www.homedepot.com/collection/kitchen/modern-prep-kitchen/id-38009',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/ab6de890-ba3c-4ed4-8e8c-7dc6dd1fc29589.jpeg'
        },
        {
          id: '38005',
          url: 'https://www.homedepot.com/collection/laundry-room/spacious-farmhouse-laundry-room/id-38005',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/dc766ab0-0c33-47d6-871d-e6c0f6604080199.jpeg'
        },
        {
          id: '38004',
          url: 'https://www.homedepot.com/collection/kitchen/gleaming-modern-kitchen/id-38004',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/e4ccfc5d-dd06-4f6c-9290-e50aea5b0386112.jpeg'
        },
        {
          id: '37990',
          url: 'https://www.homedepot.com/collection/bathroom/moody-modern-bathroom/id-37990',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3cd4fb28-3821-4a0f-978b-aa29a088b7aa192.jpeg'
        },
        {
          id: '38000',
          url: 'https://www.homedepot.com/collection/laundry-room/farmhouse-blush-kitchen/id-38000',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/c6fb72cd-b540-4075-af51-5fffe6473dea169.jpeg'
        },
        {
          id: '37985',
          url: 'https://www.homedepot.com/collection/home-office/spacious-modern-home-office/id-37985',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/670a9127-2a1d-44ff-a97d-43d4addfb98097.jpeg'
        },
        {
          id: '37981',
          url: 'https://www.homedepot.com/collection/kitchen/contrast-farmhouse-kitchen/id-37981',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/68aedd42-7b9e-4b8c-a442-1f33b62a7975172.jpeg'
        },
        {
          id: '37983',
          url: 'https://www.homedepot.com/collection/kitchen/farmhouse-flair-kitchen/id-37983',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/c3bb26c2-a4e8-40c7-8124-6b26e6a48903126.jpeg'
        },
        {
          id: '37980',
          url: 'https://www.homedepot.com/collection/kitchen/modern-paradise-kitchen/id-37980',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/96d3b269-5c4d-46bb-87d3-3ba7b4c5b2de135.jpeg'
        },
        {
          id: '37968',
          url: 'https://www.homedepot.com/collection/home-office/farmhouse-flow-home-office/id-37968',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/5144f7d3-cdb8-4766-bfeb-13a3eb32d1db168.jpeg'
        }
      ],
      visualNav: [
        {
          url: 'https://www.homedepot.com/b/Furniture-Bedroom-Furniture/Farmhouse/N-5yc1vZc7peZ1z17pru?NCNI-5',
          omsid: 308448637,
          title: 'Bedroom',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav1.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Living-Room-Furniture/Farmhouse/N-5yc1vZc7p3Z1z17pru?NCNI-5',
          omsid: 309998360,
          title: 'Living Room',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav2.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Home-Office-Furniture/Farmhouse/N-5yc1vZc7npZ1z17pru?NCNI-5',
          omsid: 308309398,
          title: 'Home Office',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav3.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Wallpaper/Farmhouse/N-5yc1vZbc0qZ1z0k109?NCNI-5',
          omsid: 313360817,
          title: 'Wallpaper',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav4.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Kitchen-Dining-Room-Furniture/Farmhouse/N-5yc1vZc7ouZ1z0k109?NCNI-5',
          omsid: 303578635,
          title: 'Kitchen & Dining',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav5.png'
        },
        {
          url: 'https://www.homedepot.com/b/Bath-Bathroom-Vanities/Farmhouse/N-5yc1vZcfv3Z1z17pru?NCNI-5',
          omsid: 303030433,
          title: 'Bathroom Vanities',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav6.png'
        },
        {
          url: 'https://www.homedepot.com/b/Flooring-Rugs-Area-Rugs/Farmhouse/N-5yc1vZarjgZ1z17pru?NCNI-5',
          omsid: 310479527,
          title: 'Area Rugs',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav7.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Mirrors/Farmhouse/N-5yc1vZbve6Z1z17yxq?NCNI-5',
          omsid: 305989592,
          title: 'Mirrors',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav8.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Entryway-Furniture/Farmhouse/N-5yc1vZc7ozZ1z17pru?NCNI-5',
          omsid: 306740500,
          title: 'Entryway',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav9.png'
        },
        {
          url: 'https://www.homedepot.com/b/Featured-Products-Lighting-Trending-Interior-Lighting/Farmhouse/N-5yc1vZ1z18gixZ1z17pru?NCNI-5&experienceName=default',
          omsid: 308058159,
          title: 'Indoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav10.png'
        },
        {
          url: 'https://www.homedepot.com/b/Lighting-Outdoor-Lighting/Farmhouse/N-5yc1vZc7qvZ1z17pru?NCNI-5',
          omsid: 312871435,
          title: 'Outdoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav11.png'
        },
        {
          url: 'https://www.homedepot.com/b/Outdoors-Patio-Furniture/Farmhouse/N-5yc1vZbx4oZ1z17pru',
          omsid: 203974326,
          title: 'Patio Furniture',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizFarmhouse-VizNav12.png'
        }
      ]
    },
    Coastal: {
      campaignId: '1371',
      description: 'You’re happiest by the ocean. You thrive in the salt air. You\'re laid-back in spirit and coastal in style. Beachy and nautical spaces top your list, playing up natural light, organic materials and colors from the sea and sky. You pine for sun-bleached pieces; eye-catching accents with louvered panels, rattan, canvas and wicker. In your eyes, watery blues are the best, green hues are simply sublime, and sandy neutrals set the stage for this easy, breezy design.',
      elements: [
        {
          type: 'element-1',
          title: 'Rattan or Wicker',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-Style1.png'
        },
        {
          type: 'element-2',
          title: 'Colors from the Sea',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-Style2.png'
        },
        {
          type: 'element-3',
          title: 'Distressed Wood Finishes',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-Style3.png'
        }
      ],
      media: {
        images: [
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-classically-coastal-living-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/living-room/classically-coastal-living-room/id-38191',
            collectionId: '38191'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/DR-classically-coastal-dining-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/dining-room/classically-coastal-dining-room/id-38194',
            collectionId: '38194'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/BR-coastal-getaway-bedroom-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/bedroom/coastal-getaway-bedroom/id-364',
            collectionId: '364'
          }
        ]
      },
      rooms: [
        {
          id: '38221',
          url: 'https://www.homedepot.com/collection/bathroom/classically-coastal-bathroom/id-38221',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3b3087f0-28f9-4c70-8c3e-203b13bc0bf95.jpeg'
        },
        {
          id: '38218',
          url: 'https://www.homedepot.com/collection/bedroom/classically-coastal-guest-room/id-38218',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3d88520a-5bdf-4e75-bdf3-1f23c20aa6274.jpeg'
        },
        {
          id: '38216',
          url: 'https://www.homedepot.com/collection/bedroom/classically-coastal-bedroom/id-38216',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/1a33bd97-83d2-4f0a-b4d6-0f25b4a972cf3.jpeg'
        },
        {
          id: '38196',
          url: 'https://www.homedepot.com/collection/entryway/classically-coastal-mudroom/id-38196',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/387b9120-5899-4a31-87b1-bc36be674a0c0.jpeg'
        },
        {
          id: '38198',
          url: 'https://www.homedepot.com/collection/entryway/classically-coastal-entryway/id-38198',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/52598006-aebd-4a32-9276-80d822728d0a0.jpeg'
        },
        {
          id: '38194',
          url: 'https://www.homedepot.com/collection/dining-room/classically-coastal-dining-room/id-38194',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3e0e90c4-9e87-46c1-b9c2-8e7bba0f73c92.jpeg'
        },
        {
          id: '38188',
          url: 'https://www.homedepot.com/collection/outdoor/classically-coastal-patio/id-38188',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b205e76f-74ec-40fe-9487-32d5ad555b480.jpeg'
        },
        {
          id: '38191',
          url: 'https://www.homedepot.com/collection/living-room/classically-coastal-living-room/id-38191',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/a201c2a0-e034-43e9-9890-503466443a871.jpeg'
        },
        {
          id: '38012',
          url: 'https://www.homedepot.com/collection/bathroom/luxury-classic-master-bathroom/id-38012',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/4e85fe41-b70b-44a1-be4c-2c6f33b434d2147.jpeg'
        },
        {
          id: '37995',
          url: 'https://www.homedepot.com/collection/living-room/playful-coastal-living-room/id-37995',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/d3dfbb65-2a19-4c4e-bae4-699ce81e3ee5140.jpeg'
        },
        {
          id: '37988',
          url: 'https://www.homedepot.com/collection/living-room/coastal-gathering-living-room/id-37988',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/238d7af4-7c04-4db5-b0a3-0bd3766c4eb0128.jpeg'
        },
        {
          id: '37971',
          url: 'https://www.homedepot.com/collection/living-room/coastal-elegance-living-room/id-37971',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/62275e6c-7ecd-42aa-867d-9cd3ad864b6d134.jpeg'
        },
        {
          id: '37960',
          url: 'https://www.homedepot.com/collection/entryway/coastal-vibes-entryway/id-37960',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/2c1389e7-0163-4e41-a9ce-03e986259b55195.jpeg'
        },
        {
          id: '37928',
          url: 'https://www.homedepot.com/collection/kitchen/cheery-coastal-kitchen/id-37928',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/d0b16885-577d-496d-8e38-cf04ccbd9e1d162.jpeg'
        },
        {
          id: '37768',
          url: 'https://www.homedepot.com/collection/home-office/breezy-bold-home-office/id-37768',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/625c51d6-bc1e-4871-b0cc-6bfb395fd05060.jpeg'
        },
        {
          id: '37754',
          url: 'https://www.homedepot.com/collection/living-room/cozy-corner-living-room/id-37754',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/eba0f018-c8a3-4222-8a96-ca2a6eea0ef669.jpeg'
        },
        {
          id: '37560',
          url: 'https://www.homedepot.com/collection/living-room/modern-geometric-living-room/id-37560',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/926f90d5-a79c-4bcf-ad5e-791c16c1f9e959.jpeg'
        },
        {
          id: '37541',
          url: 'https://www.homedepot.com/collection/bathroom/breezy-coastal-bathroom/id-37541',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/90c3c1fa-b84e-4a25-859b-14c219169b6884.jpeg'
        },
        {
          id: '37507',
          url: 'https://www.homedepot.com/collection/dorm-room/cheerful-whimsy-dorm-room/id-37507',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/0779b4ee-0f43-4744-afce-b4b7db9f61121.jpeg'
        },
        {
          id: '37506',
          url: 'https://www.homedepot.com/collection/bedroom/airy-cottage-bedroom/id-37506',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b17582f7-755a-49c9-bc9e-eb1deaa3562e0.jpeg'
        }
      ],
      visualNav: [
        {
          url: 'https://www.homedepot.com/b/Furniture-Bedroom-Furniture/Coastal/N-5yc1vZc7peZ1z0jyl2?NCNI-5',
          omsid: 308420006,
          title: 'Bedroom',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav1.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Living-Room-Furniture/Coastal/N-5yc1vZc7p3Z1z0jyl2?NCNI-5',
          omsid: 309998234,
          title: 'Living Room',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav2.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Home-Office-Furniture/Coastal/N-5yc1vZc7npZ1z0jyl2?NCNI-5',
          omsid: 303578699,
          title: 'Home Office',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav3.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Wallpaper/Coastal/N-5yc1vZbc0qZ1z178e4?NCNI-5',
          omsid: 313428919,
          title: 'Wallpaper',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav4.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Kitchen-Dining-Room-Furniture/Coastal/N-5yc1vZc7ouZ1z178e4?NCNI-5',
          omsid: 305128838,
          title: 'Kitchen & Dining',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav5.png'
        },
        {
          url: 'https://www.homedepot.com/b/Bath-Bathroom-Vanities/Coastal/N-5yc1vZcfv3Z1z0jyl2?NCNI-5',
          omsid: 312559190,
          title: 'Bathroom Vanities',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav6.png'
        },
        {
          url: 'https://www.homedepot.com/b/Flooring-Rugs-Area-Rugs/Coastal/N-5yc1vZarjgZ1z0jyl2?NCNI-5',
          omsid: 207102144,
          title: 'Area Rugs',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav7.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Mirrors/Coastal/N-5yc1vZbve6Z1z17ywk?sortby=toprated&sortorder=desc',
          omsid: 309762843,
          title: 'Mirrors',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav8.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Entryway-Furniture/Coastal/N-5yc1vZc7ozZ1z0jyl2?NCNI-5',
          omsid: 302034903,
          title: 'Entryway',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav9.png'
        },
        {
          url: 'https://www.homedepot.com/b/Featured-Products-Lighting-Trending-Interior-Lighting/Coastal/N-5yc1vZ1z18gixZ1z0jyl2&experienceName=default',
          omsid: 303025756,
          title: 'Indoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav10.png'
        },
        {
          url: 'https://www.homedepot.com/b/Lighting-Outdoor-Lighting/Coastal/N-5yc1vZc7qvZ1z0jyl2?sortby=topsellers&sortorder=desc',
          omsid: 304602154,
          title: 'Outdoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav11.png'
        },
        {
          url: 'https://www.homedepot.com/b/Outdoors-Patio-Furniture/Coastal/N-5yc1vZbx4oZ1z0jyl2?NCNI-5',
          omsid: 310170863,
          title: 'Patio Furniture',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizCoastal-VizNav12.png'
        }
      ]
    },
    'Mid Century Modern': {
      campaignId: '1376',
      description: 'Your mood is multifaceted, multicolored and mid-century. Look around your home and you\'ll see simplified, uncluttered, understated details. The low profiles of your favorite furniture pieces are accented by gently curving silhouettes and lean tapered legs. Your style can be demure or daring, showing off a range of colors from calm neutrals to vibrant, energetic shades. You\'d happily travel in time – back to the 40s and 50s – but bringing mid-century style to your spaces will have to do for now.',
      elements: [
        {
          type: 'element-1',
          title: 'Tapered Legs',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-Style1.png'
        },
        {
          type: 'element-2',
          title: 'Low Profile',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-Style2.png'
        },
        {
          type: 'element-3',
          title: 'Classic Sputnick Lighting',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-Style3.png'
        }
      ],
      media: {
        images: [
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-in-the-moment-living-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/living-room/in-the-moment-living-room/id-32252',
            collectionId: '32252'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/DR-mod-mix-dining-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/dining-room/mod-mix-dining-room/id-36896',
            collectionId: '36896'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/BR-mod-mix-bedroom-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/bedroom/mod-mix-bedroom/id-36899',
            collectionId: '36899'
          }
        ]
      },
      rooms: [
        {
          id: '38326',
          url: 'https://www.homedepot.com/collection/dining-room/chic-retreat-dining-area/id-38326',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/c5ace81b-43ea-4428-bb47-a7d528ba7c0211.jpeg'
        },
        {
          id: '38114',
          url: 'https://www.homedepot.com/collection/entryway/colorful-comfort-entryway/id-38114',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b23800f8-3818-4e66-ad0c-3c222f5eea4315.jpeg'
        },
        {
          id: '38031',
          url: 'https://www.homedepot.com/collection/kitchen/playful-mid-century-kitchen/id-38031',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/25029512-8134-4a7b-bee7-a02b4b28b27f108.jpeg'
        },
        {
          id: '38108',
          url: 'https://www.homedepot.com/collection/bedroom/colorful-comfort-bedside/id-38108',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/af1d85eb-df8d-4704-a5bb-d7364c784c4613.jpeg'
        },
        {
          id: '37978',
          url: 'https://www.homedepot.com/collection/kitchen/mid-century-twist-living-room/id-37978',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3b01eade-c86c-4dbe-9354-61c2321f6534180.jpeg'
        },
        {
          id: '37982',
          url: 'https://www.homedepot.com/collection/kitchen/natural-mid-century-kitchen/id-37982',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/d4d49dfc-4ec5-4c79-bc76-fe3dc6c7a2a8130.jpeg'
        },
        {
          id: '37974',
          url: 'https://www.homedepot.com/collection/home-office/mid-century-twist-home-office/id-37974',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/44228685-01bc-469b-8fd0-0888a5f69c03116.jpeg'
        },
        {
          id: '37975',
          url: 'https://www.homedepot.com/collection/living-room/mid-century-cool-living-room/id-37975',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/9b867205-3dc3-4b93-9648-a57fa5f16886129.jpeg'
        },
        {
          id: '37958',
          url: 'https://www.homedepot.com/collection/kitchen/open-modern-kitchen/id-37958',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/013f3ffd-93bd-4b40-9d92-931f285d7bec146.jpeg'
        },
        {
          id: '37965',
          url: 'https://www.homedepot.com/collection/living-room/mid-century-lounge-living-room/id-37965',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/0f75f958-0530-4cde-9d0e-510d967e231b114.jpeg'
        },
        {
          id: '37957',
          url: 'https://www.homedepot.com/collection/home-office/modern-view-home-office/id-37957',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/6cb74ec8-dee0-4e36-888c-301e25f088c8144.jpeg'
        },
        {
          id: '37916',
          url: 'https://www.homedepot.com/collection/living-room/shapely-modern-living-room/id-37916',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/08b79ced-3cee-41b8-8691-522e18c5a844191.jpeg'
        },
        {
          id: '37772',
          url: 'https://www.homedepot.com/collection/home-office/clean-modern-home-office/id-37772',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/07c5e291-1699-45dc-a485-47ef0cc9260291.jpeg'
        },
        {
          id: '37757',
          url: 'https://www.homedepot.com/collection/living-room/vintage-modern-living-room/id-37757',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/83bdb5ba-a67c-4bda-a6e1-44a0527a711748.jpeg'
        },
        {
          id: '37753',
          url: 'https://www.homedepot.com/collection/living-room/mod-marble-living-room/id-37753',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3121482a-809b-4734-bf00-28d4aaeacb9274.jpeg'
        },
        {
          id: '37553',
          url: 'https://www.homedepot.com/collection/kitchen/pop-of-color-kitchen/id-37553',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/2b1c6956-a2ab-4889-9197-11573df4111635.jpeg'
        },
        {
          id: '37606',
          url: 'https://www.homedepot.com/collection/bathroom/retro-relaxation-bathroom/id-37606',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/01afcee4-0823-42fc-ab1f-5a24a8303d9930.jpeg'
        },
        {
          id: '37518',
          url: 'https://www.homedepot.com/collection/bedroom/mid-century-meets-boho-bedroom/id-37518',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b81acecc-edd5-4bdf-a30e-974fc37847bc5.jpeg'
        },
        {
          id: '37531',
          url: 'https://www.homedepot.com/collection/dining-room/mod-mid-century-dining-room/id-37531',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/a7c75a07-fe24-436d-a061-4ad847d9010e31.jpeg'
        },
        {
          id: '37205',
          url: 'https://www.homedepot.com/collection/living-room/modern-drama-living-room/id-37205',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/e5e8b206-c83c-48d9-a3e7-2370ab282a04411.jpeg'
        }
      ],
      visualNav: [
        {
          url: 'https://www.homedepot.com/b/Furniture-Bedroom-Furniture/Mid-Century-Modern/N-5yc1vZc7peZ1z17ik0?NCNI-5',
          omsid: 312281504,
          title: 'Bedroom',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav1.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Living-Room-Furniture/Mid-Century-Modern/N-5yc1vZc7p3Z1z17ik0?NCNI-5',
          omsid: 305704395,
          title: 'Living Room',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav2.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Home-Office-Furniture/Mid-Century-Modern/N-5yc1vZc7npZ1z17ik0?NCNI-5',
          omsid: 308420008,
          title: 'Home Office',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav3.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Wallpaper/Mid-Century-Modern/N-5yc1vZbc0qZ1z17706?NCNI-5',
          omsid: 313340304,
          title: 'Wallpaper',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav4.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Kitchen-Dining-Room-Furniture/Mid-Century-Modern/N-5yc1vZc7ouZ1z17706?NCNI-5',
          omsid: 313467025,
          title: 'Kitchen & Dining',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav5.png'
        },
        {
          url: 'https://www.homedepot.com/b/Bath-Bathroom-Vanities/Mid-Century-Modern/N-5yc1vZcfv3Z1z17ik0?NCNI-5',
          omsid: 305669861,
          title: 'Bathroom Vanities',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav6.png'
        },
        {
          url: 'https://www.homedepot.com/b/Flooring-Rugs-Area-Rugs/Mid-Century-Modern/N-5yc1vZarjgZ1z17ik0?NCNI-5',
          omsid: 310328376,
          title: 'Area Rugs',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav7.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Mirrors/Mid-Century-Modern/N-5yc1vZbve6Z1z17z3j?NCNI-5',
          omsid: 309762842,
          title: 'Mirrors',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav8.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Entryway-Furniture/Mid-Century-Modern/N-5yc1vZc7ozZ1z17ik0?NCNI-5',
          omsid: 310613083,
          title: 'Entryway',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav9.png'
        },
        {
          url: 'https://www.homedepot.com/b/Featured-Products-Lighting-Trending-Interior-Lighting/Mid-Century-Modern/N-5yc1vZ1z18gixZ1z17ik0?NCNI-5&experienceName=default',
          omsid: 312192836,
          title: 'Indoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav10.png'
        },
        {
          url: 'https://www.homedepot.com/b/Lighting-Outdoor-Lighting/Mid-Century-Modern/N-5yc1vZc7qvZ1z17ik0?NCNI-5',
          omsid: 312501272,
          title: 'Outdoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav11.png'
        },
        {
          url: 'https://www.homedepot.com/b/Outdoors-Patio-Furniture/Mid-Century-Modern/N-5yc1vZbx4oZ1z17ik0?NCNI-5',
          omsid: 312390847,
          title: 'Patio Furniture',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizMCModern-VizNav12.png'
        }
      ]
    },
    Industrial: {
      campaignId: '1370',
      description: 'You\'re intriguing and unexpected, just like your industrial style. Open, lofted spaces blow you away. Exposed brick is what makes you tick. Your style is big on architectural details and raw, pared-back materials. You mix vintage pieces with modern accents to create a look that\'s uniquely you. Bringing warmth to unforgiving spaces is where you thrive, whether it\'s with soft upholstery, supple leather, rich wood tones or faux fur. From eat-in areas to sleeping suites, your spaces are ones that wow.',
      elements: [
        {
          type: 'element-1',
          title: 'Metal Accents',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-Style1.png'
        },
        {
          type: 'element-2',
          title: 'Metal Light Fixtures',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-Style2.png'
        },
        {
          type: 'element-3',
          title: 'Concrete',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-Style3.png'
        }
      ],
      media: {
        images: [
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-IndustrialAtmosphere-Living-Room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/living-room/industrial-atmosphere-living-room/id-38482',
            collectionId: '38482'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/DR-IndustrialAtmosphere-Dining-Room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/dining-room/industrial-atmosphere-dining-room/id-38484',
            collectionId: '38484'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/BR-IndustrialAtmosphere-Bedroom-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/bedroom/industrial-atmosphere-bedroom/id-38486',
            collectionId: '38486'
          }
        ]
      },
      rooms: [
        {
          id: '38010',
          url: 'https://www.homedepot.com/collection/home-office/industrial-excellence-home-office/id-38010',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/7b31308a-835e-48d4-a7eb-02e3522b422d119.jpeg'
        },
        {
          id: '37967',
          url: 'https://www.homedepot.com/collection/home-office/sleek-statement-home-office/id-37967',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/6a77f038-380c-4dd8-b73c-fb21e8aa88fe141.jpeg'
        },
        {
          id: '37963',
          url: 'https://www.homedepot.com/collection/kitchen/farmhouse-duo-kitchen/id-37963',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/98fc3c01-1f98-4ed2-8a38-6bd6cd19a433133.jpeg'
        },
        {
          id: '37952',
          url: 'https://www.homedepot.com/collection/home-office/cozy-nook-home-office/id-37952',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/d2ab5989-4302-4884-b3da-16a35edfa324154.jpeg'
        },
        {
          id: '37930',
          url: 'https://www.homedepot.com/collection/home-office/crisp-industrial-home-office/id-37930',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/79ebb820-1261-42f7-b482-3c37caa59160166.jpeg'
        },
        {
          id: '37774',
          url: 'https://www.homedepot.com/collection/living-room/urban-modern-living-room/id-37774',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3b6c0d8e-7e8a-4166-bd31-91ba8a4dbef854.jpeg'
        },
        {
          id: '37767',
          url: 'https://www.homedepot.com/collection/entryway/rustic-industrial-entryway/id-37767',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/d4a60409-5451-409c-8ee1-a75eb3f4798782.jpeg'
        },
        {
          id: '37755',
          url: 'https://www.homedepot.com/collection/home-office/sleek-shared-home-office/id-37755',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/ff68d0b2-2805-4a30-b6bb-8c33194af1f694.jpeg'
        },
        {
          id: '37751',
          url: 'https://www.homedepot.com/collection/home-office/urban-modern-home-office/id-37751',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/952c239a-34b9-46f4-bf01-e5522be892ef46.jpeg'
        },
        {
          id: '36938',
          url: 'https://www.homedepot.com/collection/living-room/bold-bungalow-living-room/id-36938',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/0fc6138a-c06e-4e2a-8d89-b4e4ab45a9230.jpeg'
        },
        {
          id: '35551',
          url: 'https://www.homedepot.com/collection/dining-room/farmhouse-retreat-dining-room/id-35551',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/80e985ec-8df4-48b3-a3c3-b796825ec24611.jpeg'
        },
        {
          id: '36888',
          url: 'https://www.homedepot.com/collection/home-office/mod-mix-office/id-36888',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/673224bf-385a-435b-8bc0-79c1015e9aaa12.jpeg'
        },
        {
          id: '35542',
          url: 'https://www.homedepot.com/collection/bathroom/modern-moment-bathroom/id-35542',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/eca2ad69-8228-4e43-8c7a-88501c3a4b1d102.jpeg'
        },
        {
          id: '35513',
          url: 'https://www.homedepot.com/collection/living-room/modern-moment-living-room/id-35513',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/5fdda1fe-0e41-46c0-be43-9d3aa487305193.jpeg'
        },
        {
          id: '35510',
          url: 'https://www.homedepot.com/collection/entryway/modern-moment-entry/id-35510',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/2e704052-24d2-49e3-bb5f-a156a1922f4292.jpeg'
        },
        {
          id: '32878',
          url: 'https://www.homedepot.com/collection/dining-room/in-the-moment-dining-room/id-32878',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3dd30b43-15db-460e-b183-21b31514c5fb36.jpeg'
        },
        {
          id: '30780',
          url: 'https://www.homedepot.com/collection/dining-room/sleek-swedish-style-dining-room/id-30780',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b61db746-55c6-447d-9ae9-78fa9abddb3c42.jpeg'
        },
        {
          id: '32875',
          url: 'https://www.homedepot.com/collection/entryway/in-the-moment-entryway/id-32875',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/78f8dfc3-4396-4716-90be-f60307512bce1.jpeg'
        },
        {
          id: '26839',
          url: 'https://www.homedepot.com/collection/entryway/a-nod-to-mod-entry/id-26839',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/bf67d40a-2356-4f18-b1ea-1e937aaf0c1b511.jpeg'
        },
        {
          id: '985',
          url: 'https://www.homedepot.com/collection/bedroom/chic-loft-bedroom/id-985',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/7361d13f-eae7-4ef6-bb89-de449229c8cb.jpeg'
        }
      ],
      visualNav: [
        {
          url: 'https://www.homedepot.com/b/Furniture-Bedroom-Furniture/Industrial/N-5yc1vZc7peZ1z0jyle?NCNI-5',
          omsid: 308476616,
          title: 'Bedroom',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav1.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Living-Room-Furniture/Industrial/N-5yc1vZc7p3Z1z0jyle?NCNI-5',
          omsid: 312363595,
          title: 'Living Room',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav2.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Home-Office-Furniture/Industrial/N-5yc1vZc7npZ1z0jyle?NCNI-5',
          omsid: 313254519,
          title: 'Home Office',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav3.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Wallpaper/Industrial/N-5yc1vZbc0qZ1z178cw?NCNI-5',
          omsid: 301874132,
          title: 'Wallpaper',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav4.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Kitchen-Dining-Room-Furniture/Industrial/N-5yc1vZc7ouZ1z178cw?NCNI-5',
          omsid: 309090386,
          title: 'Kitchen & Dining',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav5.png'
        },
        {
          url: 'https://www.homedepot.com/b/Bath-Bathroom-Vanities/Industrial/N-5yc1vZcfv3Z1z0jyle?NCNI-5',
          omsid: 313484358,
          title: 'Bathroom Vanities',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav6.png'
        },
        {
          url: 'https://www.homedepot.com/b/Flooring-Rugs-Area-Rugs/Industrial/N-5yc1vZarjgZ1z0jyle?NCNI-5',
          omsid: 313114078,
          title: 'Area Rugs',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav7.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Mirrors/Industrial/N-5yc1vZbve6Z1z17yzc?NCNI-5',
          omsid: 304172642,
          title: 'Mirrors',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav8.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Entryway-Furniture/Industrial/N-5yc1vZc7ozZ1z0jyle?NCNI-5',
          omsid: 310613137,
          title: 'Entryway',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav9.png'
        },
        {
          url: 'https://www.homedepot.com/b/Featured-Products-Lighting-Trending-Interior-Lighting/Industrial/N-5yc1vZ1z18gixZ1z0jyle?NCNI-5&experienceName=default',
          omsid: 311626463,
          title: 'Indoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav10.png'
        },
        {
          url: 'https://www.homedepot.com/b/Lighting-Outdoor-Lighting/Industrial/N-5yc1vZc7qvZ1z0jyle?NCNI-5',
          omsid: 300161633,
          title: 'Outdoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav11.png'
        },
        {
          url: 'https://www.homedepot.com/b/Outdoors-Patio-Furniture/Industrial/N-5yc1vZbx4oZ1z0jyle?NCNI-5',
          omsid: 304983428,
          title: 'Patio Furniture',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizIndustrial-VizNav12.png'
        }
      ]
    },
    Bohemian: {
      campaignId: '1375',
      description: 'Your experiences shape your world and your home is just your landing pad. You decorate your spaces with details from around the globe, relishing in your last adventure and planning your next one. This global style gives each of your rooms a laid-back vibe that sets the stage for your carefully curated vintage-style furniture and lighting. You love mixing artisanal textiles and rugs, displays of collected pieces, and one-of-a-kind items from your travels. The world is yours, one trip at a time.',
      elements: [
        {
          type: 'element-1',
          title: 'Globally Inspired Textiles',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-Style1.png'
        },
        {
          type: 'element-2',
          title: 'Hand Carved Wood',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-Style2.png'
        },
        {
          type: 'element-3',
          title: 'Textured Accents',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-Style3.png'
        }
      ],
      media: {
        images: [
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-eclectic-voyage-living-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/living-room/eclectic-voyage-living/id-32275',
            collectionId: '32275'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/DR-organic-elegance-dining-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/dining-room/organic-elegance-dining-room/id-37868',
            collectionId: '37868'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/BR-organic-elegance-master-bedroom-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/bedroom/organic-elegance-master-bedroom/id-37880',
            collectionId: '37880'
          }
        ]
      },
      rooms: [
        {
          id: '38239',
          url: 'https://www.homedepot.com/collection/living-room/petite-suite-living-room/id-38239',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/51ac18a1-43b8-4586-ab30-d315d67385d50.jpeg'
        },
        {
          id: '38161',
          url: 'https://www.homedepot.com/collection/bedroom/seeking-alexi/id-38161',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/2f81bc08-bfa9-449c-8b62-d17a290c87ae0.jpeg'
        },
        {
          id: '37999',
          url: 'https://www.homedepot.com/collection/bathroom/botanical-oasis-bathroom/id-37999',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/81ad46b1-edae-4f33-91d6-84299a825025175.jpeg'
        },
        {
          id: '37991',
          url: 'https://www.homedepot.com/collection/kitchen/breezy-modern-kitchen/id-37991',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/2d2c6d07-fd92-41b9-9c56-9d000eb7f4f793.jpeg'
        },
        {
          id: '37880',
          url: 'https://www.homedepot.com/collection/bedroom/organic-elegance-master-bedroom/id-37880',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/0b80e94a-13ad-4e25-ab5d-e2e9efc5261c35.jpeg'
        },
        {
          id: '37882',
          url: 'https://www.homedepot.com/collection/bedroom/organic-elegance-guest-bedroom/id-37882',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/d553763f-1db5-44f3-8e90-bfc4b50cef9f36.jpeg'
        },
        {
          id: '37878',
          url: 'https://www.homedepot.com/collection/bedroom/organic-elegance-bedroom/id-37878',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/2ce6eeff-a882-4b7c-8466-4dcd12afeea534.jpeg'
        },
        {
          id: '37770',
          url: 'https://www.homedepot.com/collection/bedroom/boho-meets-mod-bedroom/id-37770',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/73fcd2c0-9038-4cee-81c0-5fdda3db9093118.jpeg'
        },
        {
          id: '37865',
          url: 'https://www.homedepot.com/collection/entryway/organic-elegance-entryway/id-37865',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/bd4209fd-40b0-483a-a600-80de4b38705229.jpeg'
        },
        {
          id: '37758',
          url: 'https://www.homedepot.com/collection/kitchen/bold-boho-kitchen/id-37758',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/ed6b4ae8-6b05-4d09-8cb1-57cc5040bdba58.jpeg'
        },
        {
          id: '37644',
          url: 'https://www.homedepot.com/collection/bedroom/real-simple-home-master-bedroom/id-37644',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/33a10436-7a6f-4907-ac24-e11955248d5d0.jpeg'
        },
        {
          id: '37607',
          url: 'https://www.homedepot.com/collection/kitchen/bright-boho-kitchen/id-37607',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3ce199db-21fb-4987-93bc-1dc653bbb980137.jpeg'
        },
        {
          id: '37606',
          url: 'https://www.homedepot.com/collection/bathroom/retro-relaxation-bathroom/id-37606',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/01afcee4-0823-42fc-ab1f-5a24a8303d9930.jpeg'
        },
        {
          id: '36941',
          url: 'https://www.homedepot.com/collection/bedroom/bold-bungalow-bedroom/id-36941',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/d1b51785-0f5d-4b50-90d8-95143829a8d130.jpeg'
        },
        {
          id: '32266',
          url: 'https://www.homedepot.com/collection/dining-room/eclectic-voyage-dining/id-32266',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/057b3ef2-a9b7-48d4-82f0-69beee2ca6f30.jpeg'
        },
        {
          id: '993',
          url: 'https://www.homedepot.com/collection/living-room/signature-styles-by-courtney-clymer/id-993',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/f7620d2f-4c34-491d-9794-a03527725db5.jpeg'
        },
        {
          id: '984',
          url: 'https://www.homedepot.com/collection/bedroom/bold-bedroom/id-984',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/30f1a7b6-8964-429a-acc0-fb46e3c40610.jpeg'
        },
        {
          id: '962',
          url: 'https://www.homedepot.com/collection/living-room/global-living/id-962',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/de99c226-bd85-4177-9870-6557f9d4ea87.jpeg'
        },
        {
          id: '873',
          url: 'https://www.homedepot.com/collection/living-room/bohemian-meets-mid-century/id-873',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/c28f340d-7474-47b6-b29d-7ec2bd126130.jpeg'
        },
        {
          id: '968',
          url: 'https://www.homedepot.com/collection/entryway/going-green/id-968',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/4b45a144-4a00-40f1-9ede-736d9ccf1513.jpeg'
        }
      ],
      visualNav: [
        {
          url: 'https://www.homedepot.com/b/Furniture-Bedroom-Furniture/Bohemian/N-5yc1vZc7peZ1z0jyld?NCNI-5',
          omsid: 303770935,
          title: 'Bedroom',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav1.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Living-Room-Furniture/Bohemian/N-5yc1vZc7p3Z1z0jyld?NCNI-5',
          omsid: 309755928,
          title: 'Living Room',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav2.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Home-Office-Furniture/Bohemian/N-5yc1vZc7npZ1z0jyld?NCNI-5',
          omsid: 311773521,
          title: 'Home Office',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav3.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Wallpaper/Bohemian/N-5yc1vZbc0qZ1z178ce?NCNI-5',
          omsid: 203869004,
          title: 'Wallpaper',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav4.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Kitchen-Dining-Room-Furniture/Bohemian/N-5yc1vZc7ouZ1z178ce?NCNI-5',
          omsid: 301113238,
          title: 'Kitchen & Dining',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav5.png'
        },
        {
          url: 'https://www.homedepot.com/b/Bath-Bathroom-Vanities/Bohemian/N-5yc1vZcfv3Z1z0jyld?NCNI-5',
          omsid: 301779687,
          title: 'Bathroom Vanities',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav6.png'
        },
        {
          url: 'https://www.homedepot.com/b/Flooring-Rugs-Area-Rugs/Bohemian/N-5yc1vZarjgZ1z0jyld?NCNI-5',
          omsid: 311805777,
          title: 'Area Rugs',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav7.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Mirrors/Bohemian/N-5yc1vZbve6Z1z17z0x?NCNI-5',
          omsid: 309765050,
          title: 'Mirrors',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav8.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Entryway-Furniture/Bohemian/N-5yc1vZc7ozZ1z0jyld?NCNI-5',
          omsid: 302647504,
          title: 'Entryway',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav9.png'
        },
        {
          url: 'https://www.homedepot.com/b/Featured-Products-Lighting-Trending-Interior-Lighting/Bohemian/N-5yc1vZ1z18gixZ1z0jyld?NCNI-5&experienceName=default',
          omsid: 305034875,
          title: 'Indoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav10.png'
        },
        {
          url: 'https://www.homedepot.com/b/Lighting-Outdoor-Lighting/Bohemian/N-5yc1vZc7qvZ1z0jyld?NCNI-5',
          omsid: 313451155,
          title: 'Outdoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav11.png'
        },
        {
          url: 'https://www.homedepot.com/b/Outdoors-Patio-Furniture/Bohemian/N-5yc1vZbx4oZ1z0jyld?NCNI-5',
          omsid: 206826979,
          title: 'Patio Furniture',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizBohemian-VizNav12.png'
        }
      ]
    },
    Glam: {
      campaignId: '1374',
      description: 'You\'re posh and sophisticated with a dash of fabulousity. Your style is glam and you live for the allure. In your spaces you blend an airy, upscale feel with supple fabrics, glittering metals and sparkling accessories. Gold, silver, copper and champagne metallics mingle effortlessly in each of your luxe looks. Mirrored finishes and marble shine next to your favorite faux fur, velvet and satin fabrics, creating an air of elegance and extravagance that has you written all over it.',
      elements: [
        {
          type: 'element-1',
          title: 'Luxurious Fabrics',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-Style1.png'
        },
        {
          type: 'element-2',
          title: 'Faux Fur',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-Style2.png'
        },
        {
          type: 'element-3',
          title: 'Glittering Metals',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-Style3.png'
        }
      ],
      media: {
        images: [
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-GildedGlam-living-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/bedroom/gilded-glam-living-room/id-38488',
            collectionId: '38488'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/DR-GildedGlam-dining-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/dining-room/gilded-glam-dining-room/id-38490',
            collectionId: '38490'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/2020-MarchHDH-ShadowShoot-Day3AM-1475-L-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/bedroom/chic-bedroom-retreat/id-38361',
            collectionId: '38361'
          }
        ]
      },
      rooms: [
        {
          id: '38249',
          url: 'https://www.homedepot.com/collection/bedroom/petite-suite-bedroom/id-38249',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/9da6fddf-f9c8-41eb-8c99-ff51c672467d2.jpeg'
        },
        {
          id: '38001',
          url: 'https://www.homedepot.com/collection/bathroom/modern-glam-spa/id-38001',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/2c1be9aa-90aa-41f3-af83-9825a6d9c659121.jpeg'
        },
        {
          id: '38032',
          url: 'https://www.homedepot.com/collection/bathroom/showstopper-classic-bathroom/id-38032',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/1a6ef950-aee1-40c7-a5ee-d7fcf0c5e7de177.jpeg'
        },
        {
          id: '37984',
          url: 'https://www.homedepot.com/collection/kitchen/luxe-glamour-kitchen/id-37984',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/a8ac2b20-ef80-49e6-89f7-28fc9e04f9c2149.jpeg'
        },
        {
          id: '38032',
          url: 'https://www.homedepot.com/collection/bathroom/showstopper-classic-bathroom/id-38032',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/1a6ef950-aee1-40c7-a5ee-d7fcf0c5e7de177.jpeg'
        },
        {
          id: '37784',
          url: 'https://www.homedepot.com/collection/entryway/upscale-earthy-entryway/id-37784',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/5c8c7bb5-a05d-4d7d-b417-502eb06e14c768.jpeg'
        },
        {
          id: '37973',
          url: 'https://www.homedepot.com/collection/home-office/classic-sophisticate-home-office/id-37973',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b061b600-92e3-4e4f-b6a0-7b89487f555b145.jpeg'
        },
        {
          id: '37977',
          url: 'https://www.homedepot.com/collection/bathroom/glamour-oasis-bathroom/id-37977',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/f15e9ac5-15ee-4ca2-9859-a8bd32e8038f182.jpeg'
        },
        {
          id: '37744',
          url: 'https://www.homedepot.com/collection/bedroom/cool-classics-guestroom/id-37744',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/2729761a-90f9-42c3-8afa-698b220407741.jpeg'
        },
        {
          id: '37779',
          url: 'https://www.homedepot.com/collection/bedroom/moody-modern-bedroom/id-37779',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/89dbc4aa-84fd-402b-9e49-7e821aa0870a193.jpeg'
        },
        {
          id: '37689',
          url: 'https://www.homedepot.com/collection/dining-room/holiday-glamour-dining-room/id-37689',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3c09e6c6-a157-4bca-b52a-72768c9859f510.jpeg'
        },
        {
          id: '37610',
          url: 'https://www.homedepot.com/collection/bedroom/charm-and-class-bedroom/id-37610',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/cf99dc98-1b95-4a5a-ac6e-8c84d1cab21363.jpeg'
        },
        {
          id: '37603',
          url: 'https://www.homedepot.com/collection/bathroom/high-class-master-bath/id-37603',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/1562e77a-2184-47ff-afc7-208746d1ba8218.jpeg'
        },
        {
          id: '37563',
          url: 'https://www.homedepot.com/collection/bedroom/elegant-retreat-bedroom/id-37563',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/8fbceb74-fe8a-4150-ab1f-2c4a53117f6545.jpeg'
        },
        {
          id: '37556',
          url: 'https://www.homedepot.com/collection/bathroom/majestic-marble-bathroom/id-37556',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/8b2ae1e0-2b2d-4d5b-a78f-4e78f09b32f436.jpeg'
        },
        {
          id: '37543',
          url: 'https://www.homedepot.com/collection/bathroom/classic-glam-bathroom/id-37543',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/1c2671d2-21b7-45a7-8420-ecbfa7f9da5110.jpeg'
        },
        {
          id: '37539',
          url: 'https://www.homedepot.com/collection/kids-room/bold-and-bright-kids-room/id-37539',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/c43a1420-6de6-474e-8a82-0625e988307d20.jpeg'
        },
        {
          id: '37536',
          url: 'https://www.homedepot.com/collection/dining-room/classic-chic-dining-room/id-37536',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/42ac39b0-8884-4ed8-9538-24c30badbb8d11.jpeg'
        },
        {
          id: '37525',
          url: 'https://www.homedepot.com/collection/kitchen/open-concept-kitchen/id-37525',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/a0c7f7c8-8959-427e-b50a-eb1859c38fad37.jpeg'
        },
        {
          id: '1004',
          url: 'https://www.homedepot.com/collection/living-room/vintage-glam-living-room/id-1004',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/e906b823-b69e-4628-8c21-c54985b736d4.jpeg'
        }
      ],
      visualNav: [
        {
          url: 'https://www.homedepot.com/b/Furniture-Bedroom-Furniture/Glam/N-5yc1vZc7peZ1z0jyll?NCNI-5',
          omsid: 308740716,
          title: 'Bedroom',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav1.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Living-Room-Furniture/Glam/N-5yc1vZc7p3Z1z0jyll?NCNI-5',
          omsid: 311764405,
          title: 'Living Room',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav2.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Home-Office-Furniture/Glam/N-5yc1vZc7npZ1z0jyll?NCNI-5',
          omsid: 313426368,
          title: 'Home Office',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav3.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Wallpaper/Glam/N-5yc1vZbc0qZ1z178ew?NCNI-5',
          omsid: 311220650,
          title: 'Wallpaper',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav4.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Kitchen-Dining-Room-Furniture/Glam/N-5yc1vZc7ouZ1z178ew?NCNI-5',
          omsid: 309483258,
          title: 'Kitchen & Dining',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav5.png'
        },
        {
          url: 'https://www.homedepot.com/b/Bath-Bathroom-Vanities/Glam/N-5yc1vZcfv3Z1z0jyll?NCNI-5',
          omsid: 203092928,
          title: 'Bathroom Vanities',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav6.png'
        },
        {
          url: 'https://www.homedepot.com/b/Flooring-Rugs-Area-Rugs/Glam/N-5yc1vZarjgZ1z0jyll?NCNI-5',
          omsid: 302216665,
          title: 'Area Rugs',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav7.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Mirrors/Glam/N-5yc1vZbve6Z1z17z0c?NCNI-5',
          omsid: 308829202,
          title: 'Mirrors',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav8.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Entryway-Furniture/Glam/N-5yc1vZc7ozZ1z0jyll?NCNI-5',
          omsid: 311455812,
          title: 'Entryway',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav9.png'
        },
        {
          url: 'https://www.homedepot.com/b/Featured-Products-Lighting-Trending-Interior-Lighting/Glam/N-5yc1vZ1z18gixZ1z0jyll?NCNI-5&experienceName=default',
          omsid: 207051306,
          title: 'Indoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav10.png'
        },
        {
          url: 'https://www.homedepot.com/b/Lighting-Outdoor-Lighting/Glam/N-5yc1vZc7qvZ1z0jyll?NCNI-5',
          omsid: 311437946,
          title: 'Outdoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav11.png'
        },
        {
          url: 'https://www.homedepot.com/b/Outdoors-Patio-Furniture/Glam/N-5yc1vZbx4oZ1z0jyll?NCNI-5',
          omsid: 308531525,
          title: 'Patio Furniture',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizGlam-VizNav12.png'
        }
      ]
    },
    Traditional: {
      campaignId: '1378',
      description: 'A love for the classics has you forever turning to traditional design. This timeless style offers the stately details, sumptuous furnishings and an abundance of upscale accessories that you adore. Your home is filled with dark-finished woods, rich colors and touchable textures. Silhouettes in your space are artfully curved with soft lines and sumptuous upholstery. Your favorite rooms are overflowing with depth, layers and dimensionality.',
      elements: [
        {
          type: 'element-1',
          title: 'Dark Wood Finishes',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-Style1.png'
        },
        {
          type: 'element-2',
          title: 'Rich Color Palettes',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-Style2.png'
        },
        {
          type: 'element-3',
          title: 'Scrolled Arms',
          image: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-Style3.png'
        }
      ],
      media: {
        images: [
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-cool-classics-living-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/living-room/cool-classics-living-room/id-37853',
            collectionId: '37853'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/DR-classic-glamour-dining-room-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/dining-room/classic-glamour-dining-room/id-37192',
            collectionId: '37192'
          },
          {
            url: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/BR-global-old-world-bedroom-SQ.jpg',
            sizes: [
              '65',
              '100',
              '145',
              '300',
              '400',
              '600',
              '1000'
            ],
            type: 'IMAGE',
            collection: 'https://www.homedepot.com/collection/bedroom/global-old-world-bedroom/id-1053',
            collectionId: '1053'
          }
        ]
      },
      rooms: [
        {
          id: '38290',
          url: 'https://www.homedepot.com/collection/bedroom/classic-bedroom/id-38290',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/e0977292-1427-4f37-b69e-92e067e6eea15.jpeg'
        },
        {
          id: '38242',
          url: 'https://www.homedepot.com/collection/dining-room/petite-suite-dining-room/id-38242',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b5c5ebd7-3e18-4106-800b-905f04dfbc622.jpeg'
        },
        {
          id: '37669',
          url: 'https://www.homedepot.com/collection/bedroom/classically-christmas-bedroom/id-37669',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/7ad173ad-0ead-4b4f-b4ba-1739a5c4b6b62.jpeg'
        },
        {
          id: '38100',
          url: 'https://www.homedepot.com/collection/living-room/starring-the-chesterfield-sofa/id-38100',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3e9abdb1-d880-4b24-86f6-1398bf97a3eb9.jpeg'
        },
        {
          id: '38080',
          url: 'https://www.homedepot.com/collection/entryway/earthy-cottage-entryway/id-38080',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/f597a749-4c11-4786-b05b-43958295520d1.jpeg'
        },
        {
          id: '38078',
          url: 'https://www.homedepot.com/collection/living-room/earthy-cottage-living-room/id-38078',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/6f646e41-9c65-45af-9042-aab0e1dcb1fd0.jpeg'
        },
        {
          id: '38092',
          url: 'https://www.homedepot.com/collection/bedroom/gentle-comforts-bedroom/id-38092',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b3eafd40-d9ae-49a7-8e63-9b52e8406e9b8.jpeg'
        },
        {
          id: '38097',
          url: 'https://www.homedepot.com/collection/entryway/gentle-comforts-mudroom/id-38097',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/227c4b5f-b8e1-48d7-b53b-48562d36fbd36.jpeg'
        },
        {
          id: '37859',
          url: 'https://www.homedepot.com/collection/bedroom/cool-classics-bedroom/id-37859',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/8672c20b-6303-4235-ad94-f3f4ca28869927.jpeg'
        },
        {
          id: '37856',
          url: 'https://www.homedepot.com/collection/home-office/cool-classics-office/id-37856',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/7af7b451-c075-4864-83a4-81ebf531c8bf26.jpeg'
        },
        {
          id: '35493',
          url: 'https://www.homedepot.com/collection/dining-room/instant-classic-dining-room/id-35493',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/fac3806c-c0dc-4e6a-9880-f3e4ed1d80a485.jpeg'
        },
        {
          id: '37192',
          url: 'https://www.homedepot.com/collection/dining-room/classic-glamour-dining-room/id-37192',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/963d469a-de69-4654-b083-4dead08c15da23.jpeg'
        },
        {
          id: '37055',
          url: 'https://www.homedepot.com/collection/dining-room/airy-classic-dining-room/id-37055',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/e7626f48-987f-48df-bb98-0c21d24065e59.jpeg'
        },
        {
          id: '32850',
          url: 'https://www.homedepot.com/collection/bathroom/cottage-bathroom/id-32850',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/29996dff-170e-4260-8f87-9a2a100001c324.jpeg'
        },
        {
          id: '32229',
          url: 'https://www.homedepot.com/collection/bedroom/natural-classic-closet/id-32229',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/f93e9f0a-747f-4b1d-a992-8f19edc68fa60.jpeg'
        },
        {
          id: '1015',
          url: 'https://www.homedepot.com/collection/entryway/new-traditions-mudroom/id-1015',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/4fa1271b-0ee3-42ad-b7f3-a06f7fa353dd.jpeg'
        },
        {
          id: '1003',
          url: 'https://www.homedepot.com/collection/living-room/urban-modern-living-room/id-1003',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/34627116-69b0-49f3-9af7-79f218aa5e5c.jpeg'
        },
        {
          id: '931',
          url: 'https://www.homedepot.com/collection/dining-room/global-old-world-dining-room/id-931',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/b7aa4638-54da-4d16-a36d-206cb6eed189.jpeg'
        },
        {
          id: '37786',
          url: 'https://www.homedepot.com/collection/dining-room/rustic-cottage-dining-room/id-37786',
          imageUrl: 'https://images.homedepot-static.com/lifestyleimages/1024x682/3a94ff99-94de-4025-8c58-42483a30fe7696.jpeg'
        }
      ],
      visualNav: [
        {
          url: 'https://www.homedepot.com/b/Furniture-Bedroom-Furniture/Traditional/N-5yc1vZc7peZ1z1bwac?NCNI-5',
          omsid: 303559610,
          title: 'Bedroom',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav1.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Living-Room-Furniture/Traditional/N-5yc1vZc7p3Z1z1bwac?NCNI-5',
          omsid: 205181920,
          title: 'Living Room',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav2.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Home-Office-Furniture/Traditional/N-5yc1vZc7npZ1z1bwac?NCNI-5',
          omsid: 303578140,
          title: 'Home Office',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav3.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Wallpaper/Classic/N-5yc1vZbc0qZ1z0wukf?NCNI-5',
          omsid: 206041333,
          title: 'Wallpaper',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav4.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Kitchen-Dining-Room-Furniture/Classic/N-5yc1vZc7ouZ1z0wukf?sortby=topsellers&sortorder=desc',
          omsid: 309136669,
          title: 'Kitchen & Dining',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav5.png'
        },
        {
          url: 'https://www.homedepot.com/b/Bath-Bathroom-Vanities/Traditional/N-5yc1vZcfv3Z1z1bwac?NCNI-5',
          omsid: 301704800,
          title: 'Bathroom Vanities',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav6.png'
        },
        {
          url: 'https://www.homedepot.com/b/Flooring-Rugs-Area-Rugs/Traditional/N-5yc1vZarjgZ1z1bwac?NCNI-5',
          omsid: 310164911,
          title: 'Area Rugs',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav7.png'
        },
        {
          url: 'https://www.homedepot.com/b/Home-Decor-Mirrors/Classic/N-5yc1vZbve6Z1z17yvb?sortby=topsellers&sortorder=desc',
          omsid: 204398805,
          title: 'Mirrors',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav8.png'
        },
        {
          url: 'https://www.homedepot.com/b/Furniture-Entryway-Furniture/Traditional/N-5yc1vZc7ozZ1z1bwac?NCNI-5',
          omsid: 309647804,
          title: 'Entryway',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav9.png'
        },
        {
          url: 'https://www.homedepot.com/b/Featured-Products-Lighting-Trending-Interior-Lighting/Traditional/N-5yc1vZ1z18gixZ1z1bwac?NCNI-5&experienceName=default',
          omsid: 313087964,
          title: 'Indoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav10.png'
        },
        {
          url: 'https://www.homedepot.com/b/Lighting-Outdoor-Lighting/Traditional/N-5yc1vZc7qvZ1z1bwac?NCNI-5',
          omsid: 204347416,
          title: 'Outdoor Lighting',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav11.png'
        },
        {
          url: 'https://www.homedepot.com/b/Outdoors-Patio-Furniture/Traditional/N-5yc1vZbx4oZ1z1bwac?NCNI-5',
          omsid: 305253964,
          title: 'Patio Furniture',
          imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/HDH20-StyleQuizTraditional-VizNav12.png'
        }
      ]
    }
  },
  styles: [
    {
      imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-american-farmhouse-living-SQ.jpg',
      styleCorrelation: 'Farmhouse',
      url: 'https://www.homedepot.com/room/farmhouse'
    },
    {
      imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-bold-bungalow-living-room-SQ.jpg',
      styleCorrelation: 'Industrial',
      url: 'https://www.homedepot.com/room/industrial'
    },
    {
      imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-airy-classic-sunroom-SQ.jpg',
      styleCorrelation: 'Cottage',
      url: 'https://www.homedepot.com/room/cottage'
    },
    {
      imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-vintage-glam-living-SQ.jpg',
      styleCorrelation: 'Glam',
      url: 'https://www.homedepot.com/room/glam'
    },
    {
      imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-cool-classics-living-room-SQ.jpg',
      styleCorrelation: 'Traditional',
      url: 'https://www.homedepot.com/room/classic'
    },
    {
      imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-in-the-moment-living-room-SQ.jpg',
      styleCorrelation: 'Mid Century Modern',
      url: 'https://www.homedepot.com/room/mid-century-modern'
    },
    {
      imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-eclectic-voyage-living-SQ.jpg',
      styleCorrelation: 'Bohemian',
      url: 'https://www.homedepot.com/room/bohemian'
    },
    {
      imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-classically-coastal-living-room-SQ.jpg',
      styleCorrelation: 'Coastal',
      url: 'https://www.homedepot.com/room/coastal'
    },
    {
      imageUrl: 'https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/fetch/collections/staticImages/LR-modern-moment-living-room-SQ.jpg',
      styleCorrelation: 'Modern',
      url: 'https://www.homedepot.com/room/modern'
    }
  ]
};